var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderReceipt',{attrs:{"header":"ดูรายละเอียดใบสั่งซื้อ","img_header":_vm.header_image,"link_back":"stock/storage/addproducttostock"}}),_c('StoragePO_detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }